module.exports = __webpack_public_path__ + "static/img/city.612f007b.png";